export default class NetworkDomain {
    readonly _value: string;

    constructor(value: string) {
        NetworkDomain.validate(value);
        this._value = NetworkDomain.normalizeDomainString(value);
    }

    get value(): string {
        return this._value;
    }

    static normalizeDomainString(domain: string): string {
        let normalized = domain.trim();
        const atIndex = normalized.indexOf('@');
        if (atIndex >= 0) {
            normalized = normalized.slice(atIndex + 1);
        }
        return normalized.toLowerCase();
    }

    static validate(domain: string) {
        if (!domain || domain.trim() === '') {
            throw new Error("Network domain must have a value.");
        }

        let normalized = this.normalizeDomainString(domain);

        const labels = normalized.split('.');
        const labelPattern = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
        // All labels except the last must match labelPattern and be at least 2 chars
        // The last label (TLD) must be at least 2 chars and match labelPattern
        if (
            labels.length < 2 ||
            labels.some((label, idx) => {
                if (idx === labels.length - 1) {
                    // Final label (TLD)
                    return label.length < 2 || !labelPattern.test(label);
                } else {
                    // Other labels
                    return label.length < 1 || !labelPattern.test(label);
                }
            })
        ) {
            throw new Error("Network domain is not valid: should be in the format 'example.com'.");
        }
    }

    equals(other: NetworkDomain): boolean {
        return this.value.toLowerCase() === other.value.toLowerCase();
    }
}